import React from 'react';
import classNames from 'classnames';
import Tag from './Tag';

const CriteriaTags = ({ tags, toggleTag, selectedTagId, allCriteria }) => {
  const tagClassNames = classNames('AddCriteriaModal-tag', {
    'AddCriteriaModal-selectedTag': selectedTagId === null,
  });

  return (
    <div className="AddCriteriaModal-criteriaTags d-f ai-c">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div className={tagClassNames} onClick={() => toggleTag(null)}>
        {allCriteria}
      </div>
      {tags.map(tag => (
        <Tag
          tag={tag}
          toggleTag={toggleTag}
          key={tag.id}
          selectedTagId={selectedTagId}
        />
      ))}
    </div>
  );
};

export default CriteriaTags;
